module.exports = __webpack_public_path__ + "02_hair_silver.ee7a4a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/02_hair_silver.png
// module id = kTQp
// module chunks = 0